import * as React from 'react';
import { Card, CounterBadge, Box, Heading } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';

export function CompleteSetupHeader({
  badgeCounter,
}: {
  badgeCounter: number;
}) {
  const t = useTranslation();
  return (
    <Card.Header
      title={
        <Box verticalAlign="middle">
          <Box marginRight="10px">
            <Heading appearance="H3" dataHook="manage-apps-pending-title">
              {t('manage-apps.complete-setup-apps.card-header.action-required')}
            </Heading>
          </Box>
          <CounterBadge skin="danger" dataHook="manage-apps-counter-badge">
            {badgeCounter}
          </CounterBadge>
        </Box>
      }
    />
  );
}
